import styled from 'styled-components';

export const ScopeWrap = styled.span<{
  tagColor: string;
  disabled?: boolean;
}>`
  display: inline-block;
  box-sizing: border-box;
  border-left: 10px solid ${p => p.tagColor};
  line-height: 32px;
  height: 36px;
  cursor: pointer;
  background-color: #F6F6F6;
  padding: 2px 7px;
  font-weight: normal;
  opacity: ${p => p.disabled ? 0.4 : 1};
`;